<template>
  <div class="s-component img-bg" :style="{...defaultBg.style, backgroundImage: `url(${defaultBg.src}`}">
    <!-- 导航列表 -->
    <div class="nav img-bg" :style="{...tagBg.style, backgroundImage: `url(${tagBg.src}`}">
      <div class="nav-list">
        <img v-if="navIndex === 0" :src="tagList[0].activeImg" alt="" class="nav-tag-img-active"/>
        <img v-else :src="tagList[0].img" alt="" class="nav-tag-img" @click="clickSideBar(0, 'nav1')"/>

        <img v-if="navIndex === 1" :src="tagList[1].activeImg" alt="" class="nav-tag-img-active"/>
        <img v-else :src="tagList[1].img" alt="" class="nav-tag-img" @click="clickSideBar(1, 'nav2')"/>

        <img v-if="navIndex === 2" :src="tagList[2].activeImg" alt="" class="nav-tag-img-active"/>
        <img v-else :src="tagList[2].img" alt="" class="nav-tag-img" @click="clickSideBar(2, 'nav3')"/>

        <img v-if="navIndex === 3" :src="tagList[3].activeImg" alt="" class="nav-tag-img-active"/>
        <img v-else :src="tagList[3].img" alt="" class="nav-tag-img" @click="clickSideBar(3, 'nav4')"/>

        <img v-if="navIndex === 4" :src="tagList[4].activeImg" alt="" class="nav-tag-img-active"/>
        <img v-else :src="tagList[4].img" alt="" class="nav-tag-img" @click="clickSideBar(4, 'nav5')"/>

        <img v-if="navIndex === 5" :src="tagList[5].activeImg" alt="" class="nav-tag-img-active"/>
        <img v-else :src="tagList[5].img" alt="" class="nav-tag-img" @click="clickSideBar(5, 'nav6')"/>
      </div>
      <div class="website img-bg" :style="{...websiteImg.style, backgroundImage: `url(${websiteImg.src}`}">
        <a :href="websiteLink" target="_blank"></a>
      </div>
    </div>
    <!-- kv模块 -->
    <div :ref="navList[0].refText" class="img-bg" :style="{...kvBg.style, position: 'relative', backgroundImage: `url(${kvBg.src}`}">
      <img :src="timeImg.src" alt="" :style="{...timeImg.style}"/>
      <a :href="signLink" target="_blank"><img :src="btnSign.src" alt="" :style="{...btnSign.style}"/></a>
    </div>
    <!-- 活动日程 -->
    <div :ref="navList[1].refText" class="one">
          <img :src="title1.src" :style="{...title1.style}" alt=""/>
          <img :src="schedule.src" :style="{...schedule.style}" alt=""/>
    </div>
    <!-- 参与方式 -->
    <div :ref="navList[2].refText" class="two" style="position: relative">
      <img :src="join.src" :style="{...join.style}" alt=""/>
      <img :src="title2.src" :style="{...title2.style}" alt=""/>
    </div>
    <!-- 活动奖励 -->
    <div :ref="navList[3].refText" class="three">
      <img :src="title3.src" :style="{...title3.style}" alt=""/>
      <div class="three-box img-bg"  :style="{...awardBg.style, backgroundImage: `url(${awardBg.src}`, position:'relative'}">
          <div class="award-tag">
<!--            <img v-if="awardTag === 0" :src="awardList[0].activeImg" alt="" class="award-tag-img-active"/>
            <img v-else :src="awardList[0].img" alt="" class="award-tag-img" @click="selectTag(0)"/>

            <img v-if="awardTag === 1" :src="awardList[1].activeImg" alt="" class="award-tag-img-active"/>
            <img v-else :src="awardList[1].img" alt="" class="award-tag-img" @click="selectTag(1)"/>

            <img v-if="awardTag === 2" :src="awardList[2].activeImg" alt="" class="award-tag-img-active"/>
            <img v-else :src="awardList[2].img" alt="" class="award-tag-img" @click="selectTag(2)"/>-->
            <div v-for="(item, index) in awardList" :key="index">
              <img v-if="awardTag === index" :src="item.activeImg" alt="" class="award-tag-img-active" :style="styleAwardTagImgActive"/>
              <img v-else :src="item.img" alt="" class="award-tag-img" @click="selectTag(index)" :style="styleAwardTagImg"/>
            </div>

          </div>
          <div class="award-content">
              <div v-for="(item,index) in awardList" :key="index">
                  <img v-show="awardTag===index" :src="item.awardImg" alt="" :class="['award-img', 'animate__animated']"/>
              </div>
          </div>
      </div>
    </div>
    <!-- 精彩稿件 -->
    <div :ref="navList[4].refText" class="four">
      <img :src="title4.src" :style="{...title4.style}" alt=""/>
      <div class="four-box img-bg" :style="{...highlightsBg.style, backgroundImage: `url(${highlightsBg.src}`}">
        <div v-if="highlights && highlights.length>0" class="swiper-box">
            <div class="swiper-button-prev swiper_btn_l" slot="button-next" :style="{...btnSwiperLeft.style, backgroundImage: `url(${btnSwiperLeft.src}`}"></div>
            <div class="swiper-button-next swiper_btn_r" slot="button-next" :style="{...btnSwiperRight.style, backgroundImage: `url(${btnSwiperRight.src}`}"></div>
            <div class="swiper-all">
                <!-- 大轮播图 -->
                <swiper class="swiper gallery-top" :options="swiperOptionTop" ref="swiperTop">
                    <swiper-slide v-for="(item,index) in highlights" :key="index">
                        <a :href="item.link" target="_blank">
                            <img :src="item.pic_url" alt="" class="big-img"/>
                            <img :src="btnPlay.src" alt="" class="btn-play" :style="{...btnPlay.style}"/>
                        </a>
                    </swiper-slide>
                </swiper>
                <!-- 小缩略图 -->
                <swiper class="swiper gallery-thumbs" :options="swiperOptionThumbs" ref="swiperThumbs">
                    <swiper-slide v-for="(item,index) in highlights" :key="index">
                        <img :src="item.pic_url" alt="" class="small-img"/>
                        <div class="small-text">{{item.title}}</div>
                    </swiper-slide>
                </swiper>
            </div>
          </div>
      </div>
    </div>
    <!-- 活动须知 -->
    <div :ref="navList[5].refText" class="five">
      <img :src="title5.src" :style="{...title5.style}" alt=""/>
      <img :src="rule.src" :style="{...rule.style}" alt=""/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SVideoEncourageActivity',
  components: {
  },
  props: {
    defaultBg: {
      type: Object,
      required: true
    },
    kvBg: {
      type: Object,
      required: true
    },
    timeImg: {
      type: Object,
      required: true
    },
    btnSign: {
      type: Object,
      required: true
    },
    signLink: {
      type: String,
      required: true
    },
    title1: {
      type: Object,
      required: true
    },
    schedule: {
      type: Object,
      required: true
    },
    title2: {
      type: Object,
      required: true
    },
    join: {
      type: Object,
      required: true
    },
    title3: {
      type: Object,
      required: true
    },
    awardBg: {
      type: Object,
      required: true
    },
    awardList: {
      type: Array,
      required: true
    },
    awardTagImg: {
      type: String,
      required: true
    },
    awardTagImgActive: {
      type: String,
      required: true
    },
    title4: {
      type: Object,
      required: true
    },
    highlightsBg: {
      type: Object,
      required: true
    },
    btnPlay: {
      type: Object,
      required: true
    },
    btnSwiperLeft: {
      type: Object,
      required: true
    },
    btnSwiperRight: {
      type: Object,
      required: true
    },
    title5: {
      type: Object,
      required: true
    },
    rule: {
      type: Object,
      required: true
    },
    tagBg: {
      type: Object,
      required: true
    },
    tagList: {
      type: Array,
      required: true
    },
    websiteImg: {
      type: Object,
      required: true
    },
    websiteLink: {
      type: String,
      required: true
    }
  },
  computed: {
    requestAPI () {
      // eslint-disable-next-line no-undef
      return this.request ? this.request : $request
    },
    styleAwardTagImg () {
      const arr = this.awardTagImg.split(' ')
      return {
        width: arr[0] || '146px',
        height: arr[1] || '68px'
      }
    },
    styleAwardTagImgActive () {
      const arr = this.awardTagImgActive.split(' ')
      return {
        width: arr[0] || '146px',
        height: arr[1] || '77px'
      }
    }
  },
  data() {
    const navList = [
      { id: 'nav1', refText: 'nav1', name: '立即报名' },
      { id: 'nav2', refText: 'nav2', name: '活动日程' },
      { id: 'nav3', refText: 'nav3', name: '参与方式' },
      { id: 'nav4', refText: 'nav4', name: '活动奖励' },
      { id: 'nav5', refText: 'nav5', name: '精彩稿件' },
      { id: 'nav6', refText: 'nav6', name: '活动须知' }
    ];
    return {
      navList,
      navIndex: 0,
      awardTag: 0,
      highlights: [],
      swiperOptionTop: {
        loop: true,
        loopedSlides: 8,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      swiperOptionThumbs: {
        loop: true,
        loopedSlides: 8,
        spaceBetween: 16,
        centeredSlides: true,
        slidesPerView: 4,
        touchRatio: 0.2,
        slideToClickedSlide: true
      }
    }
  },
  provide() {
    return {
      $MainWrap: this
    }
  },

  inject: {
    eventBus: {
      default: null
    }
  },
  mounted() {
    // 获取初始化数据
    this.getIntiData();

    // 右侧导航栏滚动与监听滚动事件
    this.$refs[this.navList[0].refText].scrollIntoView(true);
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    // 侧边栏点击定位到页面
    clickSideBar(index, ref) {
      if (this.navIndex === index) return;
      this.navIndex = index;
      this.$refs[ref].scrollIntoView(true);
    },
    // 页面滑动定位导航栏
    handleScroll() {
      // 获取滚动时的高度
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      const kvHeight = this.$refs.nav1 && this.$refs.nav1.offsetHeight - 100;
      const oneHeight = this.$refs.nav2 && this.$refs.nav2.offsetHeight + kvHeight;
      const twoHeight = this.$refs.nav3 && this.$refs.nav3.offsetHeight + oneHeight;
      const threeHeight = this.$refs.nav4 && this.$refs.nav4.offsetHeight + twoHeight;
      const fourHeight = this.$refs.nav5 && this.$refs.nav5.offsetHeight + threeHeight - 160;
      const fiveHeight = this.$refs.nav6 && this.$refs.nav6.offsetHeight + fourHeight;

      if (scrollTop > 0 && scrollTop <= kvHeight) {
        this.navIndex = 0;
      }
      if (scrollTop > kvHeight && scrollTop <= oneHeight) {
        this.navIndex = 1;
      }
      if (scrollTop > oneHeight && scrollTop <= twoHeight) {
        this.navIndex = 2;
      }
      if (scrollTop > twoHeight && scrollTop <= threeHeight) {
        this.navIndex = 3;
      }
      if (scrollTop > threeHeight && scrollTop <= fourHeight) {
        this.navIndex = 4;
      }
      if (scrollTop > fourHeight && scrollTop <= fiveHeight) {
        this.navIndex = 5;
      }
    },
    // 选择活动奖励
    selectTag(index) {
      if (this.awardTag === index) return
      this.awardTag = index
    },
    // 获取活动亮点
    getIntiData() {
      this.requestAPI({
        url: '/v1/ugc-config',
        method: 'get'
      }).then((res) => {
        this.highlights = res.article;
        this.$nextTick(() => {
          if (res.article && res.article.length > 0) {
            this.swiperOptionTop.loopedSlides = this.highlights && this.highlights.length;
            this.swiperOptionThumbs.loopedSlides = this.highlights && this.highlights.length;
            const swiperTop = this.$refs.swiperTop.swiper;
            const swiperThumbs = this.$refs.swiperThumbs.swiper;
            swiperTop.controller.control = swiperThumbs;
            swiperThumbs.controller.control = swiperTop;
          }
        });
      });
    }
  }
}
</script>
<style lang="scss" scoped>
.img-bg {
  background-repeat: no-repeat;
  background-size: 100% 100%;
  text-align: center;
  margin: 0 auto;
}
.s-component {
  position: relative;
}
.nav{
    position: fixed;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    z-index: 2;
    .nav-list{
      position: absolute;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-end;
      height: 628px;
      top: 30px;
      right: 41px;
      .nav-tag-img{
        width: 181px;
        height: 99px;
        cursor: pointer;
      }
      .nav-tag-img-active{
        width: 192px;
        height: 99px;
      }
    }
    .website{
      a{
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }
.one, .five {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.three-box {
  position: relative;
  padding: 120px 0 0 270px;
  box-sizing: border-box;
  .award-tag {
    display: flex;
    justify-content: space-between;
    width: 1073px;
    margin-bottom: 30px;
   /* .award-tag-img-active {
      width: 292px;
      height: 153px;
    }*/
    .award-tag-img {
      /*width: 292px;
      height: 136px;*/
      cursor: pointer;
    }
  }

  .award-content {
    width: 1126px;
    margin-left: -60px;
    .award-img {
      width: 1126px;
      height: 476px;
    }

    .animate__animated {
      -webkit-animation-name: fadeInLeft;
      animation-name: fadeInLeft;
      -webkit-animation-duration: 1s;
      animation-duration: 1s;
      -webkit-animation-fill-mode: both;
      animation-fill-mode: both;
    }

    @-webkit-keyframes fadeInLeft {
      from {
        opacity: 0;
        -webkit-transform: translate3d(-100%, 0, 0);
        transform: translate3d(-100%, 0, 0);
      }

      to {
        opacity: 1;
        -webkit-transform: translate3d(0, 0, 0);
        transform: translate3d(0, 0, 0);
      }
    }

    @keyframes fadeInLeft {
      from {
        opacity: 0;
        -webkit-transform: translate3d(-100%, 0, 0);
        transform: translate3d(-100%, 0, 0);
      }

      to {
        opacity: 1;
        -webkit-transform: translate3d(0, 0, 0);
        transform: translate3d(0, 0, 0);
      }
    }
  }
}

.four-box{
      width: 1432px;
      height: 1026px;
      margin: 0 auto;
      padding: 95px 178px 0 190px;
      box-sizing: border-box;
      .swiper-box{
        position: relative;
        width: 1079px;
        .gallery-top {
          position: relative;
          width: 1056px;
          height: 594px;
          margin-bottom: 80px;
          cursor: pointer;
          .big-img{
            width: 1056px;
            height: 594px;
          }
          .btn-play{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            -webkit-transform: translate(-50%,-50%);
          }
        }
        .gallery-thumbs {
          width: 900px;
          height: 145px;
          .small-img{
            width: 210px;
            height: 118px;
            cursor: pointer;
          }
          .small-text{
            font-size: 24px;
            font-weight: 400;
            color: #773807;
            width: 210px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        .gallery-thumbs .swiper-slide .small-img {
          width: 210px;
          height: 118px;
          opacity: 0.5;
        }
        .gallery-thumbs .swiper-slide-active .small-img{
          opacity: 1;
        }
        .swiper_btn_l{
          position: absolute;
          top: 700px;
          left: 0;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          cursor: pointer;
          &:hover{
            filter: brightness(110%);
          }
        }
        .swiper_btn_r{
          position: absolute;
          top: 700px;
          right: 0;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          cursor: pointer;
          &:hover{
            filter: brightness(110%);
          }
        }
      }
}
</style>
